import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, user, allowedRoles, redirectTo }) => {
  // If user is still loading, don't redirect yet
  if (!user) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontFamily: 'Arial, sans-serif'
      }}>
        Loading...
      </div>
    );
  }
  
  const userType = user?.userType || user?.attributes?.['custom:userType'] || 'client';
  
  // Check if user has permission
  if (!allowedRoles.includes(userType)) {
    // Smart redirect based on user type
    const defaultRedirect = (userType === 'vendor' || userType === 'venue') ? '/vendor/dashboard' : '/dashboard';
    return <Navigate to={redirectTo || defaultRedirect} replace />;
  }
  
  return children;
};

export default ProtectedRoute;